module.exports = __webpack_public_path__ + "static/img/1052_small.0be1496.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1052_small.png
// module id = BGu6
// module chunks = 1